export default "__VITE_ASSET__$lrsAE_Y__"